import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { DriverLoadAlertService } from "./driver-load-alert.service";
@Component({
  selector: "app-driver-load-alert",
  templateUrl: "./driver-load-alert.component.html",
  styleUrls: ["./driver-load-alert.component.sass"],
})
export class DriverLoadAlertComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private driverLoadAlertService: DriverLoadAlertService,
    private router: Router
  ) {}

  allPosts: any[] = [];
  itemsPerPage: number = 10;
  totalItems: number = 0;
  page: number = 1;

  ngOnInit(): void {
    this.getAllDriverAlerts(this.page);
  }

  getAllDriverAlerts(page: number): void {
    this.spinner.show();
    const data = {
      limit: this.itemsPerPage,
      page: page,
    };

    this.driverLoadAlertService.getDriverAlerts(data).subscribe({
      next: (result: any) => {
        if (result.statusCode === 200) {
          this.allPosts = result.data;
          this.totalItems = result.pagination?.total || 0;
        } else {
          this.toastr.error(result.message || "Something went wrong");
        }
      },
      error: (err) => {
        this.toastr.error("API Error");
      },
      complete: () => {
        this.spinner.hide();
      },
    });
  }
}
